@if (item$ | async; as item) {
  <cx-view class="card">
    <div class="header">
      <div class="title-bar">
        <div class="title">
          <h3>
            {{ i18nRoot + '.title' | cxTranslate }}
          </h3>
        </div>
        <div class="actions">
          <a
            class="link edit"
            [class.disabled]="isInEditMode$ | async"
            [routerLink]="{ cxRoute: 'branchesEdit', params: item } | cxUrl">
            {{ i18nRoot + '.buttons.edit' | cxTranslate }}
          </a>
          <a
            class="link edit"
            (click)="delete(item.name)">
            {{ i18nRoot + '.buttons.delete' | cxTranslate }}
          </a>
        </div>
      </div>
      <a class="link close" routerLink="../">
        <cx-icon
          type="CLOSE"
          (click)="closeView($event)"
        ></cx-icon>
      </a>
    </div>
    <div class="main">
      <cx-org-message></cx-org-message>
      <section main class="details master-data">
        <div class="property">
          <h5 class="heading">{{ 'branchDetails' + '.masterData' | cxTranslate }}:</h5>
          <div class="row details-row">
            <div class="col title">
              {{ i18nRoot + '.branchId' | cxTranslate }}
            </div>
          </div>
          <div class="row details-row">
            <div class="col col-sm-11">
              {{item.branchId}}
            </div>
          </div>
          <div class="row details-row">
            <div class="col title">
              {{ i18nRoot + '.name' | cxTranslate }}
            </div>
          </div>
          <div class="row details-row">
            <div class="col col-sm-11">
              {{item.name}}
            </div>
          </div>
          <div class="row details-row">
            <div class="col col-md-7 title">
              {{ i18nRoot + '.headOffice' | cxTranslate }}
            </div>
            <div class="col col-md-5">
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="item.headOffice"
                disabled
                />
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.ownerOrManager' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.ownerOrManager}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.contactPerson' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.contactPerson}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.branchVat' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.branchVat}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.streetAndHouseNo' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.streetAndHouseNo}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-md-8 title">
                {{ i18nRoot + '.country' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.countryCode}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.postalCode' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.postalCode}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.place' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.place}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.phone' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.phone}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.fax' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.fax}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.email' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.email}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col title">
                {{ i18nRoot + '.website' | cxTranslate }}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-sm-11">
                {{item.website}}
              </div>
            </div>
            <div class="row details-row">
              <div class="col col-md-7 title">
                {{ i18nRoot + '.onlineShop' | cxTranslate }}
              </div>
              <div class="col col-md-5">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="item.onlineShop"
                  disabled
                  />
                </div>
              </div>
              <div class="row details-row">
                <div class="col col-md-7 title">
                  {{ i18nRoot + '.branchSearchExport' | cxTranslate }}
                </div>
                <div class="col col-md-5">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="item.branchSearchExport"
                    disabled
                    />
                  </div>
                </div>
                <div class="row details-row">
                  <div class="col col-md-7 title">
                    {{ i18nRoot + '.branchVendorReporting' | cxTranslate }}
                  </div>
                  <div class="col col-md-5">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [checked]="item.branchVendorReporting"
                      disabled
                      />
                    </div>
                  </div>
                </div>
              </section>
              <section main class="details">
                <h5 class="heading">{{ 'branchDetails' + '.openHours' | cxTranslate }}:</h5>
                <table class="table">
                  <thead>
                    <tr>
                      <th class="schedule-title weekday">{{ i18nRoot + '.weekday' | cxTranslate }}</th>
                      <th class="schedule-title">{{ i18nRoot + '.morning' | cxTranslate }}</th>
                      <th class="schedule-title">{{ i18nRoot + '.afternoon' | cxTranslate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (day of days; track day) {
                      <tr>
                        <td class="schedule-value schedule-days">
                          {{ i18nRoot + '.' + day | cxTranslate }}
                        </td>
                        <td class="schedule-value">
                          @if (!item[day+'MorningFrom']) {
                            <span class="time-place-holder"> {{ i18nRoot + '.timePlaceHolder' | cxTranslate }}</span>
                          }
                          <span class="time"> {{ item[day+'MorningFrom']}} - {{item[day+'MorningTo'] }} </span>
                          @if (!item[day+'MorningTo']) {
                            <span class="time-place-holder"> {{ i18nRoot + '.timePlaceHolder' | cxTranslate }}</span>
                          }
                        </td>
                        <td class="schedule-value">
                          @if (!item[day+'AfternoonFrom']) {
                            <span class="time-place-holder"> {{ i18nRoot + '.timePlaceHolder' | cxTranslate }}</span>
                          }
                          <span class="time"> {{ item[day+'AfternoonFrom']}} - {{item[day+'AfternoonTo'] }} </span>
                          @if (!item[day+'AfternoonTo']) {
                            <span class="time-place-holder"> {{ i18nRoot + '.timePlaceHolder' | cxTranslate }}</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </section>
              @if (storeFeatureGroups$ | async; as storeFeatures) {
                @if (storeFeatures.length > 0) {
                  @for (storeFeature of storeFeatures; track storeFeature) {
                    <section main class="details">
                      <div class="property features">
                        <h5 class="heading">{{storeFeature.name}}</h5>
                        <div class="features-container-details">
                          @for (feature of storeFeature.features | keyvalue; track feature) {
                            <div class="row">
                              <div class="col col-lg-10 col-md-8 col-sm-10 title">
                                {{ feature.value }}
                              </div>
                              <div class="col feature-checkbox">
                                @if (item.features && item.features.includes(feature.key)) {
                                  <input class="form-check-input" type="checkbox" name="{{feature.key}}" id="{{feature.key}}"
                                    [checked]="true" disabled/>
                                  } @else {
                                    <input class="form-check-input" type="checkbox" name="{{feature.key}}" id="{{feature.key}}"
                                      [checked]="false" disabled/>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </section>
                      }
                    }
                  }
                </div>
              </cx-view>
            }

            <router-outlet></router-outlet>

